import { render, staticRenderFns } from "./ConformanceTypeDetail.vue?vue&type=template&id=60873ab0&"
import script from "./ConformanceTypeDetail.vue?vue&type=script&lang=js&"
export * from "./ConformanceTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports